import React from 'react';
import { Dialog, AppBar, Toolbar, IconButton, Typography, Zoom, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CopilotFullScreenChatWindow from './CopilotFullScreenChatWindow';
import ChatInputField from './copilot-component/ChatInputField';
import { ETL_COPILOT } from './copilot-constant/Images';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom ref={ref} {...props} />;
});

function CopilotModal({
  open,
  onClose,
  data,
  userMessage,
  handleInputChange,
  sendUserMessage,
  handleAddNode,
  handleAddPipeline,
  disabled,
  chatHistoryEndRef,
  setUserMessage,
  etlCopilotSocketConnected,
}) {
  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'sticky', top: 0, zIndex: 1100, bgcolor: 'white', color: 'black', boxShadow: 2 }}>
        {/* Add padding directly to the Toolbar */}
        <Toolbar style={{ paddingLeft: '5em', paddingRight: '5em' }}>
          {/* Title with icon */}
          <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
            <img src={ETL_COPILOT.LOGO} alt="Copilot" style={{ height: 24, marginRight: 8 }} />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="h6" component="div">
                ETL Copilot
              </Typography>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: '50%',
                  backgroundColor: etlCopilotSocketConnected ? '#4CAF50' : '#f44336',
                }}
              />
            </Box>
          </Box>

          {/* Close button */}
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Modal content */}
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Scrollable chat window */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            padding: '10px 60px',
          }}
        >
          <CopilotFullScreenChatWindow
            data={data}
            handleAddNode={handleAddNode}
            handleAddPipeline={handleAddPipeline}
            chatHistoryEndRef={chatHistoryEndRef}
            setUserMessage={setUserMessage}
            sendUserMessage={sendUserMessage}
          />
        </Box>

        {/* Sticky TextField */}
        <Box
          sx={{
            position: 'sticky',
            bottom: 5,
            bgcolor: 'white',
            padding: '10px 60px',
            boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
            zIndex: 1000,
          }}
        >
          <ChatInputField
            userMessage={userMessage}
            handleInputChange={handleInputChange}
            sendUserMessage={sendUserMessage}
            disabled={disabled}
          />
        </Box>
      </Box>
    </Dialog>
  );
}

export default CopilotModal;
